module.exports = __webpack_public_path__ + "static/media/logo.60e8c136.svg";